<section class="success">
  <p class="title">{{ "Success" | translate }}</p>
  <p class="success-text">{{ "Success.Text" | translate }}</p>
  <a href="https://alkesoccer.com/">
    <button>
      {{ "BackToAlke" | translate }}
    </button>
  </a>
</section>